import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const ManageTeam = () => {
  const { t } = useTranslation();
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editingMember, setEditingMember] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    nameAr: '',
    nameEn: '',
    specialty: '',
    specialtyAr: '',
    specialtyEn: '',
    jobTitle: 'Doctor',
    image: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imagePreview, setImagePreview] = useState('');

  useEffect(() => {
    fetchTeam();

  }, []);

  const fetchTeam = async () => {
    try {
      const res = await axios.get('https://hasanhaji.com/api/team');

      const sortedTeam = res.data.data.teamMembers.sort((a, b) => a.order - b.order);
      setTeam(sortedTeam);
      setLoading(false);
    } catch (err) {
      setError(t('admin.errorLoadingTeam'));
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const submitData = new FormData();


      submitData.append('nameAr', formData.nameAr);
      submitData.append('nameEn', formData.nameEn);
      submitData.append('specialtyAr', formData.specialtyAr);
      submitData.append('specialtyEn', formData.specialtyEn);
      submitData.append('jobTitle', formData.jobTitle);


      const imageFile = document.getElementById('imageUpload').files[0];
      if (imageFile) {
        submitData.append('image', imageFile);
      }

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      if (editingMember) {
        await axios.patch(`https://hasanhaji.com/api/team/${editingMember.id}`, submitData, config);
      } else {
        await axios.post('https://hasanhaji.com/api/team', submitData, config);
      }

      fetchTeam();
      resetForm();
      setIsSubmitting(false);
    } catch (err) {
      console.error(err);
      setError(t('admin.errorSavingMember'));
      setIsSubmitting(false);
    }
  };

  const handleEdit = (member) => {
    setEditingMember(member);
    setFormData({
      name: member.name || '',
      nameAr: member.nameAr || member.name || '',
      nameEn: member.nameEn || member.name || '',
      specialty: member.specialty || '',
      specialtyAr: member.specialtyAr || member.specialty || '',
      specialtyEn: member.specialtyEn || member.specialty || '',
      jobTitle: member.jobTitle || 'Doctor',
      image: member.image || '',
    });
    setImagePreview(member.image || '');


    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id) => {
    if (window.confirm(t('admin.confirmDeleteMember'))) {
      try {
        await axios.delete(`https://hasanhaji.com/api/team/${id}`);
        fetchTeam();
      } catch (err) {
        setError(t('admin.errorDeletingMember'));
      }
    }
  };

  const handleMove = async (index, direction) => {
    if (loading || isSubmitting) return;

    const currentMember = team[index];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;

    if (targetIndex < 0 || targetIndex >= team.length) return;

    const targetMember = team[targetIndex];


    const newTeam = [...team];
    newTeam[index] = { ...targetMember, order: currentMember.order };
    newTeam[targetIndex] = { ...currentMember, order: targetMember.order };


    setIsSubmitting(true);
    try {

      const currentOrder = currentMember.order;
      const targetOrder = targetMember.order;

      await Promise.all([
        axios.patch(`https://hasanhaji.com/api/team/${currentMember.id}`, { order: targetOrder }),
        axios.patch(`https://hasanhaji.com/api/team/${targetMember.id}`, { order: currentOrder })
      ]);

      await fetchTeam();
    } catch (err) {
      console.error(err);
      setError(t('admin.errorReordering'));
      fetchTeam();
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setEditingMember(null);
    setFormData({
      name: '',
      nameAr: '',
      nameEn: '',
      specialty: '',
      specialtyAr: '',
      specialtyEn: '',
      jobTitle: 'Doctor',
      image: '',
    });
    setImagePreview('');
    const imageUpload = document.getElementById('imageUpload');
    if (imageUpload) imageUpload.value = '';
  };

  return (
    <div className="container-fluid py-5 bg-light">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-5">
          <h2 className="fw-bold text-primary">
            <i className="fas fa-user-md me-2"></i> {t('admin.manageTeamTitle')}
          </h2>
        </div>

        {error && (
          <div className="alert alert-danger shadow-sm border-0" role="alert">
            <i className="fas fa-exclamation-circle me-2"></i> {error}
          </div>
        )}

        <div className="row g-4">
          { }
          <div className="col-lg-4">
            <div className="card border-0 shadow-sm sticky-top" style={{ top: '20px', zIndex: 1 }}>
              <div className="card-header bg-white border-bottom-0 pt-4 px-4">
                <h5 className="card-title fw-bold mb-0 text-dark">
                  {editingMember ? t('admin.editMember') : t('admin.addMember')}
                </h5>
              </div>
              <div className="card-body p-4">
                <form onSubmit={handleSubmit}>
                  { }
                  <div className="mb-4 text-center">
                    <div className="position-relative d-inline-block">
                      <div
                        className="rounded-circle bg-light d-flex align-items-center justify-content-center border"
                        style={{ width: '120px', height: '120px', overflow: 'hidden', margin: '0 auto' }}
                      >
                        {imagePreview ? (
                          <img src={imagePreview} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <i className="fas fa-user fa-3x text-secondary"></i>
                        )}
                      </div>
                      <label
                        htmlFor="imageUpload"
                        className="btn btn-sm btn-primary position-absolute bottom-0 end-0 rounded-circle shadow-sm"
                        style={{ width: '32px', height: '32px', padding: '0', lineHeight: '32px' }}
                      >
                        <i className="fas fa-camera"></i>
                      </label>
                    </div>
                    <input
                      type="file"
                      className="d-none"
                      id="imageUpload"
                      accept="image/*"
                      onChange={handleImageUpload}
                    />
                  </div>

                  <div className="row g-3">
                    <div className="col-12">
                      <label className="form-label text-muted small fw-bold">{t('admin.jobTitle')}</label>
                      <select
                        className="form-select"
                        name="jobTitle"
                        value={formData.jobTitle}
                        onChange={handleChange}
                      >
                        <option value="Doctor">{t('admin.doctor')}</option>
                        <option value="Nurse">{t('admin.nurse')}</option>
                      </select>
                    </div>

                    <div className="col-6">
                      <label className="form-label text-muted small fw-bold">{t('admin.nameAr')}</label>
                      <input
                        type="text"
                        className="form-control"
                        name="nameAr"
                        value={formData.nameAr}
                        onChange={handleChange}
                        required
                        placeholder={formData.jobTitle === 'Doctor' ? t('admin.doctorNamePlaceholder') : t('admin.nurseNamePlaceholder')}
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-label text-muted small fw-bold">{t('admin.nameEn')}</label>
                      <input
                        type="text"
                        className="form-control text-start"
                        name="nameEn"
                        value={formData.nameEn}
                        onChange={handleChange}
                        required
                        placeholder={formData.jobTitle === 'Doctor' ? t('admin.doctorNameEnPlaceholder') : t('admin.nurseNameEnPlaceholder')}
                        dir="ltr"
                      />
                    </div>

                    <div className="col-6">
                      <label className="form-label text-muted small fw-bold">{t('admin.specialtyAr')}</label>
                      <input
                        type="text"
                        className="form-control"
                        name="specialtyAr"
                        value={formData.specialtyAr}
                        onChange={handleChange}
                        required
                        placeholder={t('admin.specialtyPlaceholder')}
                      />
                    </div>
                    <div className="col-6">
                      <label className="form-label text-muted small fw-bold">{t('admin.specialtyEn')}</label>
                      <input
                        type="text"
                        className="form-control text-start"
                        name="specialtyEn"
                        value={formData.specialtyEn}
                        onChange={handleChange}
                        required
                        placeholder={t('admin.specialtyEnPlaceholder')}
                        dir="ltr"
                      />
                    </div>
                  </div>

                  <div className="d-grid gap-2 mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary py-2 fw-bold"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? <span className="spinner-border spinner-border-sm me-2"></span> : <i className="fas fa-save me-2"></i>}
                      {editingMember ? t('admin.saveChanges') : t('admin.addMemberBtn')}
                    </button>
                    {editingMember && (
                      <button
                        type="button"
                        className="btn btn-light text-danger py-2"
                        onClick={resetForm}
                      >
                        {t('admin.cancel')}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>

          { }
          <div className="col-lg-8">
            <div className="card border-0 shadow-sm bg-transparent">
              <div className="card-header bg-transparent border-0 p-0 mb-3">
                <h5 className="card-title fw-bold text-dark">{t('admin.teamList')}</h5>
              </div>

              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : team.length === 0 ? (
                <div className="alert alert-info border-0 shadow-sm" role="alert">
                  <i className="fas fa-info-circle me-2"></i> {t('admin.noTeamMembers')}
                </div>
              ) : (
                <div className="row g-3">
                  {team.map((member, index) => (
                    <div className="col-md-6" key={member.id}>
                      <div className="card border-0 shadow-sm h-100 overflow-hidden member-card">
                        <div className="card-body p-3">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0">
                              <img
                                src={member.image || '/images/default-avatar.png'}
                                alt={member.name}
                                className="rounded-circle border"
                                style={{ width: '70px', height: '70px', objectFit: 'cover' }}
                                onError={(e) => { e.target.src = 'https://via.placeholder.com/70?text=Dr' }}
                              />
                            </div>
                            <div className="flex-grow-1 ms-3 me-3">
                              <div className="d-flex justify-content-between align-items-start">
                                <h6 className="fw-bold mb-1">{member.nameAr || member.name}</h6>
                                <span className={`badge ${member.jobTitle === 'Nurse' ? 'bg-info' : 'bg-primary'} rounded-pill`}>
                                  {member.jobTitle === 'Nurse' ? t('admin.nurse') : t('admin.doctor')}
                                </span>
                              </div>
                              <p className="text-muted small mb-1">{member.nameEn}</p>
                              <div className="d-flex align-items-center text-secondary small">
                                <i className="fas fa-stethoscope me-1 text-primary opacity-50"></i>
                                <span>{member.specialtyAr || member.specialty}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-footer bg-light border-0 p-2 d-flex justify-content-between align-items-center">
                          <div className="btn-group">
                            <button
                              className="btn btn-sm btn-outline-secondary border-0"
                              onClick={() => handleMove(index, 'up')}
                              disabled={index === 0 || isSubmitting}
                              title={t('admin.moveUp')}
                            >
                              <i className="fas fa-arrow-up"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-outline-secondary border-0"
                              onClick={() => handleMove(index, 'down')}
                              disabled={index === team.length - 1 || isSubmitting}
                              title={t('admin.moveDown')}
                            >
                              <i className="fas fa-arrow-down"></i>
                            </button>
                          </div>
                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-sm btn-outline-primary border-0"
                              onClick={() => handleEdit(member)}
                              title={t('admin.edit')}
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                            <button
                              className="btn btn-sm btn-outline-danger border-0"
                              onClick={() => handleDelete(member.id)}
                              title={t('admin.delete')}
                            >
                              <i className="fas fa-trash-alt"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .member-card {
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }
        .member-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
        }
      `}</style>
    </div>
  );
};

export default ManageTeam;
